module.exports = __webpack_public_path__ + "static/media/credit-card.3504ab56.svg";